<div class="not-found">
  <h1>404</h1>
  <h2>{{ 'PAGES.NOT_FOUND.MESSAGE' | translate }}</h2>
</div>
